export const BASE_PATH = '/receiptlookup';
